import {type JSX, useCallback} from 'react';
import {useSelector, useStore} from 'react-redux';
import {selectHostNote} from '~/CreateFabricInvitation/reducers/details/selectors';
import {scrollEventDetailsModuleIntoView} from '~/CreateFabricInvitation/utils/misc';
import {UPDATE_EVENT_DETAILS} from '~/common/fabric/reducers/details/constants';
import {Typography} from '~library/atoms/Typography';
import {TextEditor} from '~library/organisms/TextEditor';

export const Notes = (): JSX.Element => {
  const store = useStore();
  const notes: string = useSelector(selectHostNote);

  const handleChange = useCallback(
    (newNotes: string) => {
      store.dispatch({
        type: UPDATE_EVENT_DETAILS,
        payload: {notes: newNotes},
      });
      scrollEventDetailsModuleIntoView();
    },
    [store]
  );

  return (
    <div className="create-flow__form-section event-details__notes">
      <Typography variant="label2" size="small" className="input-label">
        Host note
      </Typography>
      <TextEditor
        minRows={5}
        value={notes}
        onChange={handleChange}
        onFocus={scrollEventDetailsModuleIntoView}
        id="host-message"
        data-qa-id="event-notes"
        maxLength={5000}
        placeholder="Consider adding parking info, contact number, venue requirements, dress code, entertainment schedule, etc."
        toolbarId="host-note-toolbar"
      />
    </div>
  );
};
